import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Zap } from "lucide-react";

const tileSrc = "https://static.prod-images.emergentagent.com/jobs/432d7502-8e49-47be-aa92-bd971f421dad/images/9a8ec1647d8475ff18cb10a4dfcdf446c7cbf8a9fa0d33e3d3d3fab2161903f7.png";

export const Hero = () => {
  return (
    <section className="relative overflow-hidden pt-16 md:pt-24 pb-20 md:pb-28" data-testid="hero-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 relative">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          <div className="lg:col-span-7 relative">
            <div className="corner-bracket tl" />
            <div className="corner-bracket tr hidden md:block" />
            <div className="pl-2 md:pl-6 pr-2 pt-6 pb-2">
              <div className="pill rise rise-1" data-testid="hero-pill">
                <Zap size={12} /> Done For You In 72–96 Hours
              </div>
              <h1 className="rise rise-2 mt-6 font-display font-bold tracking-tighter text-white text-[40px] leading-[1.02] sm:text-5xl lg:text-6xl xl:text-7xl">
                You're losing customers <br className="hidden sm:block" />
                every day <span className="text-[#3B9EFF]">you're not posting.</span>
              </h1>
              <p className="rise rise-3 mt-6 text-lg md:text-xl text-[#A0AABF] max-w-2xl leading-relaxed">
                Get 5 professional videos and 5 branded images made for your business in
                72–96 hours — without lifting a finger. We fix that for{" "}
                <span className="text-white font-semibold">$99.99</span>.
              </p>
              <div className="rise rise-4 mt-8 flex flex-wrap gap-4">
                <Link to="/offer/pack-99" className="btn-primary" data-testid="hero-cta-99">
                  Get $99.99 Content Pack <ArrowRight size={18} />
                </Link>
                <Link to="/offer/monthly-175" className="btn-secondary" data-testid="hero-cta-175">
                  Go Monthly — $175/mo <ArrowRight size={18} />
                </Link>
              </div>
              <div className="rise rise-5 mt-8 flex flex-wrap gap-5 text-sm text-[#A0AABF]">
                <span className="flex items-center gap-2">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#3B9EFF]" /> No calls
                </span>
                <span className="flex items-center gap-2">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#3B9EFF]" /> No contracts
                </span>
                <span className="flex items-center gap-2">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#3B9EFF]" /> 72–96h delivery
                </span>
              </div>
            </div>
          </div>
          <div className="lg:col-span-5 relative">
            <div className="relative aspect-square w-full max-w-[520px] mx-auto">
              <div className="absolute inset-0 rounded-3xl border border-[#3B9EFF]/20 overflow-hidden">
                <img
                  src={tileSrc}
                  alt="Content tile mosaic"
                  className="w-full h-full object-cover opacity-95"
                />
                <div className="absolute inset-0 bg-gradient-to-tr from-[#080C14] via-transparent to-transparent" />
              </div>
              <div className="absolute -bottom-6 -left-6 bg-[#0B111D] border border-[#3B9EFF]/30 rounded-xl px-5 py-4 shadow-[0_0_40px_rgba(59,158,255,0.15)]">
                <p className="font-accent text-[10px] text-[#3B9EFF]">DELIVERED</p>
                <p className="font-display text-2xl font-bold">10 posts</p>
                <p className="text-xs text-[#A0AABF]">ready to post.</p>
              </div>
              <div className="absolute -top-5 -right-5 bg-[#0B111D] border border-[#3B9EFF]/30 rounded-xl px-5 py-3 shadow-[0_0_40px_rgba(59,158,255,0.15)]">
                <p className="font-accent text-[10px] text-[#3B9EFF]">TURNAROUND</p>
                <p className="font-display text-xl font-bold">72–96 hrs.</p>
              </div>
              <div className="corner-bracket bl" />
              <div className="corner-bracket br" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
